// extracted by mini-css-extract-plugin
export default {"recos":"s2-z","productCardOverride":"t2-z","rowHasBadge":"u2-z"};